// extracted by mini-css-extract-plugin
export default {"overlay":"Wy-z","bodyOpen":"Xy-z","content":"Yy-z","header":"Zy-z","close":"_y-z","closeNoHeading":"az-z"};